module.exports = __webpack_public_path__ + "media/elevadizo/buqueDerecha-di-48aea810.png";